import React from "react";

export default function InfoModal({ title, description }) {
  return(
    <div>
      <h3 className="text-primary text-tiny font-semibold">{title}</h3>
      <p className="text-tiny mt-1 tex-thin">{description}</p>
    </div>
  );
}